import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { if (process.env.NODE_ENV !== "production") console.error(error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-[60vh] grid place-items-center px-6 text-center">
        <div>
          <h1 className="font-display text-3xl font-bold">Something went wrong</h1>
          <p className="text-muted-foreground mt-2">This page hit an unexpected error. Please reload and try again.</p>
          <button onClick={() => window.location.assign("/")}
                  className="mt-6 px-5 py-2.5 rounded-md bg-primary text-primary-foreground font-medium">Back to home</button>
        </div>
      </div>
    );
  }
}
